<template>
  <div class="wrap-flex">
  <!-- 需要做判断，如果是列表显示的代码，在resize-box-main  ClASS  加宽度100% ；左右显示不加-->
  <div class="resize-box-main" :style="layoutType === 'tb' ? 'width:100%' : ''">
    <!-- 列表显示 -->
    <div class="resize-box-full" v-if="layoutType === 'tb'">
      <div class="maiTxt outfullsearch p0-p15">
        <div class="flexBetween">
          <div style="table-layout:fixed;word-break:break-all;">

            <!-- 邮件索引默认title-->
            <span v-show="this.indexListStatus() === ''" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;">
            <span class="title cutout max298 float-l">{{getFolderName()}}</span>
            ：{{$i18n.t('comm_lang_0002')}}{{totalMailNums}}{{$i18n.t('comm_lang_0003')}}
            <span v-if="!folderIsStar" v-show="unreadMailNums !== 0">{{$t("wm_lang_html_392898")}}<a href="javascript:;" @click="queryUnread" class="blue2">{{$t("wm_lang_html_c247ad")}}</a><span id="unreadNum">{{unreadMailNums}}</span>{{$t("wm_lang_html_980b27")}}&nbsp;|&nbsp;<a href="javascript:;" @click="changeToRead" class="blue2">{{$t("wm_lang_html_854db2")}}</a></span>
          </span>

            <!-- 邮件索引筛选title-->
            <span v-if="this.indexListStatus() === 'filterStatus'" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;">
            <span class="title cutout float-l"><span class="blue">{{getFolderName()}}</span>
              {{filterTitItem.seen ? filterTitItem.seen : ''}}
              {{filterTitItem.answered ? filterTitItem.answered : ''}}
              {{filterTitItem.forwarded ? filterTitItem.forwarded : ''}}
              {{filterTitItem.starred ? filterTitItem.starred : ''}}
              {{filterTitItem.attached ? filterTitItem.attached : ''}}
              {{filterTitItem.priority ? filterTitItem.priority : ''}}
              {{$i18n.t('comm_lang_0004')}}({{$i18n.t('comm_lang_0002')}}{{totalMailNums}}{{$i18n.t('comm_lang_0003')}})</span>
            <span v-if="!folderIsStar" v-show="(unreadMailNums !== 0 && filterTitItem.unreadFlag) || homeAllUnread"> &nbsp;|&nbsp;<a href="javascript:;" @click="changeToRead" class="blue2">{{$t("wm_lang_html_854db2")}}</a></span>
          </span>

            <!-- 邮件索引搜索及搜索下筛选title-->
            <span v-if="this.indexListStatus() === 'searchStatus'" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;">
            <span class="title float-l"><b>{{$i18n.t('comm_lang_0005')}}{{$t("wm_lang_html_dec892")}}</b>{{$i18n.t('comm_lang_0006')}}
              <span v-if="searchTitItem.folder" class="blue">{{searchTitItem.folder}}</span>
              <span v-if="searchTitItem.from">{{$i18n.t('comm_lang_0007')}} "<span class="blue">{{searchTitItem.from}}</span>" </span>
              <span v-if="searchTitItem.to">{{$i18n.t('comm_lang_0008')}} "<span class="blue">{{searchTitItem.to}}</span>" </span>
              <span v-if="searchTitItem.subject">{{$i18n.t('comm_lang_0009')}} "<span class="blue">{{searchTitItem.subject}}</span>" </span>
              <span v-if="searchTitItem.attachName">{{$i18n.t('comm_lang_0010')}} "<span class="blue">{{searchTitItem.attachName}}</span>" </span>
              <span v-if="searchTitItem.startTime">{{$i18n.t('comm_lang_0011')}} "<span class="blue">{{searchTitItem.startTime}}</span>" {{$i18n.t('comm_lang_0012')}} "<span class="blue">{{searchTitItem.endTime}}</span>"</span>
              <span v-if="searchTitItem.attached">"<span class="blue">{{searchTitItem.attached}}</span>" </span>
              <span v-if="searchTitItem.seen">"<span class="blue">{{searchTitItem.seen}}</span>" </span>
              {{$i18n.t('comm_lang_0013')}}
              {{filterTitItem.seen ? filterTitItem.seen : ''}}
              {{filterTitItem.answered ? filterTitItem.answered : ''}}
              {{filterTitItem.forwarded ? filterTitItem.forwarded : ''}}
              {{filterTitItem.starred ? filterTitItem.starred : ''}}
              {{filterTitItem.attached ? filterTitItem.attached : ''}}
              {{filterTitItem.priority ? filterTitItem.priority : ''}}
              {{$i18n.t('comm_lang_0004')}}{{totalMailNums}}{{$i18n.t('comm_lang_0003')}}
            </span>
          </span>

            <span v-if="folderIsGarbage"> ({{$i18n.t('wm_lang_24e8a8')}}{{spamMailDeleteTime}}{{$i18n.t('comm_lang_0001')}}) <a v-if="indexInfoList" @click="deleteSpam" href="javascript:;">{{$t("wm_lang_html_ae4fd4")}}</a></span>

          </div>
          <!-- 分页 -->
          <div class="listBarPag">
            <el-dropdown size="medium" trigger="click" class="mr20" @command="handlePageTurn">
              <span class="el-dropdown-link">
                {{currentPage}}/{{totalPages}}{{$i18n.t('comm_lang_0014')}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="max-height:150px;overflow:auto;" class="nice_scroll">
                <!--<el-dropdown-item class="active">1/5</el-dropdown-item>-->
                <el-dropdown-item :command="item.c" v-for="(item, index) in pageNumbers" :key="index">{{item.c}}/{{item.t}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-link :underline="false" @click="pageTurn('prev')"><i :class="getTurnPrevFlag() ? 'el-icon-arrow-left mr10 f18 disabled' : 'el-icon-arrow-left mr10 f18'"></i></el-link>
            <el-link :underline="false" @click="pageTurn('next')"><i :class="getTurnNextFlag() ? 'el-icon-arrow-right mr10 f18 disabled' : 'el-icon-arrow-right mr10 f18'"></i></el-link>
          </div>
        </div>
     </div>
    <!-- 无数据 -->
      <div class="listEmptyBox" style="display: none;">
       <!-- 邮件 -->
       <div class="empty mailEmpty1">
         <i class="ico ico-mail-noinfo1"></i>{{$i18n.t('comm_lang_0015')}}
       </div>
       <!--<div class="empty mailEmpty2">-->
         <!--<i class="ico ico-mail-noinfo2"></i>{{$t("wm_lang_html_c4746d")}}-->
       <!--</div>-->
       <!--<div class="empty mailEmpty3">-->
         <!--<i class="ico ico-mail-noinfo3"></i><strong>2</strong>&nbsp;{{$t("wm_lang_html_a00f23")}}-->
       <!--</div>-->
       <!-- 联系人 -->
       <!--<div class="empty adressEmpty1">-->
         <!--<i class="ico ico-adress-noinfo1"></i>{{$t("wm_lang_html_196bf0")}}-->
       <!--</div>-->
       <!--<div class="empty adressEmpty2">-->
         <!--<i class="ico ico-adress-noinfo2"></i>{{$t("wm_lang_html_189c20")}}-->
       <!--</div>-->
       <!--<div class="empty adressEmpty3">-->
         <!--<i class="ico ico-adress-noinfo3"></i>{{$t("wm_lang_html_543b04")}}&nbsp;<strong>2</strong>&nbsp;{{$t("wm_lang_html_44a2c7")}}-->
       <!--</div>-->
      </div>
      <!-- 有数据 -->
      <div v-if="!indexInfoList && this.indexListStatus() !== 'searchStatus' && this.indexListStatus() !== 'filterStatus'" class="f12 mt20 m15">{{$i18n.t('comm_lang_0016')}}</div>
      <div v-if="indexInfoList && indexInfoList.length === 0 && folderIsStar && this.indexListStatus() !== 'searchStatus' && this.indexListStatus() !== 'filterStatus'" class="f12 mt20 m15">{{$i18n.t('comm_lang_0017')}}</div>
      <div class="f12 mt20 m15 w300" v-if="!indexInfoList || indexInfoList.length <= 0">
        <!--<span v-show="this.indexListStatus() !== 'searchStatus' && this.indexListStatus() === 'searchStatus'">{{$i18n.t('comm_lang_0016')}}</span>-->
        <span v-show="this.indexListStatus() === 'filterStatus'">
            {{$i18n.t('comm_lang_0018')}}
            <span style="font-weight: bold">
              {{filterTitItem.seen ? filterTitItem.seen : ''}}
              {{filterTitItem.answered ? filterTitItem.answered : ''}}
              {{filterTitItem.forwarded ? filterTitItem.forwarded : ''}}
              {{filterTitItem.starred ? filterTitItem.starred : ''}}
              {{filterTitItem.attached ? filterTitItem.attached : ''}}
              {{filterTitItem.priority ? filterTitItem.priority : ''}}
            </span>{{$i18n.t('comm_lang_0019')}}
          </span>
        <span v-show="this.indexListStatus() === 'searchStatus'" class="cutout max298">{{$i18n.t('comm_lang_0020')}}</span>
      </div>
      <div class="nice_scroll el-table-full el-table el-table--fit el-table--fluid-height el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition" style="overflow-y: auto">
        <div class="el-table__body-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width:100%;">
            <colgroup>
              <col name="el-table_1_column_1" width="45">
              <col name="el-table_1_column_2" width="80">
              <col name="el-table_1_column_3" width="20%">
              <col name="el-table_1_column_4" width="25%">
              <col name="el-table_1_column_5" width="120">
              <col name="el-table_1_column_6" width="100">
              <col name="el-table_1_column_7" width="150">
              <col name="el-table_1_column_8" width="100">
            </colgroup>
            <tbody>
            <tr :class="checkedItem(item.mailIndexId) ? 'el-table__row selectBg' : 'el-table__row'" v-for="(item, index) in indexInfoList" :key="index" @click="toNewReadMail(item)" @mouseover="overMailRow(item.mailIndexId)">
              <td rowspan="1" colspan="1" class="el-table_1_column_1  el-table-column--selection el-table__cell"><div class="cell">
                <input type="checkbox" :checked="checkedItem(item.mailIndexId)" @click.stop="handleCheckedMailChange($event,item, true)" class="pr--2"/>
              </div></td>
              <td rowspan="1" colspan="1" class="el-table_1_column_2   el-table__cell"><div class="cell">
                <p class="listIco">
                  <i v-if="item.seen === false" :title="$i18n.t('wm_lang_894a10')" class="el-icon-message-solid11 iconOn"></i>
                  <i class="el-icon-s-flag11 pr--2 mr3" :title="$i18n.t('wm_lang_cb0ed5')" style="color:#3986ee;" v-if="item.priority === 1"></i>
                  <i class="el-icon-s-promotion11 pr--2" :title="$i18n.t('wm_lang_973732')" v-if="item.forwarded === true"></i>
                  <i class="el-icon-s-comment11 pr--2" :title="$i18n.t('wm_lang_4bea88')" v-if="item.answered === true"></i>
                  <i class="el-icon-time11 pr--2 mr3" :title="$i18n.t('custom_lang_0035')" v-if="isTimingMail(item.attrFlag)"></i>
                </p>
              </div></td>
              <td v-if="!listShowFrom(item)" rowspan="1" colspan="1" class="el-table_1_column_3   el-table__cell"><div style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" :class="[{fwb: item.seen === false},'cell cutout']" :title="getListName(item)">{{getListName(item)}}</div></td>
              <td v-if="listShowFrom(item)" rowspan="1" colspan="1" class="el-table_1_column_3   el-table__cell"><div style="text-overflow: ellipsis;overflow: hidden;white-space: nowrap;" :class="[{fwb: item.seen === false},'cell cutout']" :title="getListDraftName(item)">{{getListDraftName(item)}}</div></td>
              <td rowspan="1" colspan="1" class="el-table_1_column_4   el-table__cell"><div :class="[{fwb: item.seen === false},'cell', 'el-tooltip']" :title="item.subject"><span class="ib"><i title="" @click.stop="indexMarkStar(item)" :class="[item.starred === true ? 'el-icon-star-on iconOnYellow' : 'el-icon-star-on', 'ib']" class="pr pr-1" style="padding:15px 20px;"></i></span><span :title="item.subject ? item.subject : $i18n.t('wm_lang_3b239d')">
                <span v-if="$store.state.folder.folderId === 64 || indexListStatus() === 'searchStatus' || homeAllUnread">[{{mailBelongFolder(item.folderId)}}]</span>
                {{item.subject ? item.subject : '('+$i18n.t('wm_lang_3b239d')+')'}}
              </span></div></td>
              <td rowspan="1" colspan="1" class="el-table_1_column_5   el-table__cell"><div class="cell">{{item.time}}</div></td>
              <td rowspan="1" colspan="1" class="el-table_1_column_6   el-table__cell"><div class="cell"><span class="m15"><i class="el-icon-recall-new pr--2 mr3" :title="$i18n.t('comm_lang_0026')" v-if="isRecallMail(item.undoSend)"></i><i class="el-icon-paperclip" v-if="item.attachCount > 0"></i></span></div></td>
              <td rowspan="1" colspan="1" class="el-table_1_column_7   el-table__cell"><div class="cell">{{formatDate(item.receivedTime)}}</div></td>
              <td rowspan="1" colspan="1" class="el-table_1_column_8   el-table__cell"><div class="cell">{{ bytesToSize(item.mailSize) }}</div></td>
              <!--<td rowspan="1" colspan="1" class="el-table_1_column_8   el-table__cell"><div class="cell">-->
                <!--&lt;!&ndash;<p class="listIco"><span><i v-show="currOverMail === item.mailIndexId" title=this.$i18n.t('wm_lang_316206') class="el-icon-time"></i></span><span><i title=this.$i18n.t('wm_lang_5abe91') class="el-icon-star-on"></i></span><span><i class="el-icon-paperclip" v-if="item.attachCount > 0"></i></span></p>&ndash;&gt;-->
                <!--<p class="listIco"><span></span><span><i title=this.$i18n.t('wm_lang_5abe91') class="el-icon-star-on"></i></span><span><i class="el-icon-paperclip" v-if="item.attachCount > 0"></i></span></p>-->
              <!--</div></td>-->
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!--<el-table-->
        <!--ref="multipleTable"-->
        <!--:data="indexInfoList"-->
        <!--max-height="500px"-->
        <!--tooltip-effect="dark"-->
        <!--style="width: 100%;"-->
        <!--:show-header="status"-->
        <!--@row-click="toNewReadMailTable"-->
        <!--@select="handleCheckedMailChangeTable"-->
        <!--@selection-change="handleSelectionChange">-->
        <!--<el-table-column-->
          <!--type="selection"-->
          <!--width="45">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--type="wdMsg"-->
          <!--width="30">-->
          <!--<template slot-scope="scope">-->
          <!--<p class="listIco" v-if="scope.row.seen === 0"><i class="el-icon-message-solid11 iconOn" title=this.$i18n.t('wm_lang_894a10')></i></p></template>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="sender"-->
          <!--label=this.$i18n.t('wm_lang_88c952')-->
          <!--width="200">-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="title"-->
          <!--label=this.$i18n.t('wm_lang_32c65d')-->
          <!--show-overflow-tooltip>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--label=this.$i18n.t('wm_lang_4ff1e7')-->
          <!--width="120">-->
          <!--<template slot-scope="scope">{{ scope.row.time }}</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--prop="mailSize"-->
          <!--label=this.$i18n.t('wm_lang_58f966')-->
          <!--width="120">-->
          <!--<template slot-scope="scope">{{ bytesToSize(scope.row.mailSize) }}</template>-->
        <!--</el-table-column>-->
        <!--<el-table-column-->
          <!--label=this.$i18n.t('wm_lang_2b6bc0')-->
          <!--width="120">-->
          <!--<template slot-scope="scope">-->
          <!--<p class="listIco"><i class="el-icon-time" title=this.$i18n.t('wm_lang_316206') @click="dialogFormVisible = true"></i><i class="el-icon-star-on iconOnYellow" title=this.$i18n.t('wm_lang_5abe91')></i><i v-if="scope.row.attach !== 0" class="el-icon-paperclip" title=this.$i18n.t('wm_lang_69e308')></i></p></template>-->
        <!--</el-table-column>-->
      <!--</el-table>-->
    </div>
    <!-- 左右显示 -->
    <div :class="['listBar resize-box']" v-if="layoutType === 'lr'" :style="{ width: dragWidth + 'px' }">
      <div class="maiTxt outfullsearch flexCenter" style="line-height:14px;">
        <div style="table-layout:fixed;word-break:break-all;">

          <!-- 邮件索引默认title-->
          <span v-show="this.indexListStatus() === ''" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;">
            <span class="title cutout max80 float-l">{{getFolderName()}}</span>
            ：{{$i18n.t('comm_lang_0002')}}{{totalMailNums}}{{$i18n.t('comm_lang_0003')}}
            <span v-if="!folderIsStar" v-show="unreadMailNums !== 0">{{$t("wm_lang_html_d3b98f")}}{{$i18n.t('comm_lang_0021')}}<a href="javascript:;" @click="queryUnread" class="blue2">{{$i18n.t('comm_lang_0022')}}</a><span id="unreadNum">{{unreadMailNums}}</span>{{$i18n.t('comm_lang_0003')}}&nbsp;|&nbsp;<a href="javascript:;" @click="changeToRead" class="blue2">{{$i18n.t('comm_lang_0023')}}</a></span>
          </span>

          <!-- 邮件索引筛选title-->
          <span v-if="this.indexListStatus() === 'filterStatus'" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;">
            <span class="title cutout float-l"><span class="blue">{{getFolderName()}}</span>
              {{filterTitItem.seen ? filterTitItem.seen : ''}}
              {{filterTitItem.answered ? filterTitItem.answered : ''}}
              {{filterTitItem.forwarded ? filterTitItem.forwarded : ''}}
              {{filterTitItem.starred ? filterTitItem.starred : ''}}
              {{filterTitItem.attached ? filterTitItem.attached : ''}}
              {{filterTitItem.priority ? filterTitItem.priority : ''}}
              {{$i18n.t('comm_lang_0004')}}({{$i18n.t('comm_lang_0002')}}{{totalMailNums}}{{$i18n.t('comm_lang_0003')}})</span>
            <span v-if="!folderIsStar" v-show="(unreadMailNums !== 0 && filterTitItem.unreadFlag) || homeAllUnread"> &nbsp;|&nbsp;<a href="javascript:;" @click="changeToRead" class="blue2">{{$t("wm_lang_html_854db2")}}</a></span>
          </span>

          <!-- 邮件索引搜索及搜索下筛选title-->
          <span v-if="this.indexListStatus() === 'searchStatus'" class="crumbs outFullSearch" style=" word-wrap: break-word; overflow:hidden;">
            <span class="title float-l"><b>{{$i18n.t('comm_lang_0005')}}{{$t("wm_lang_html_dec892")}}</b>{{$i18n.t('comm_lang_0006')}}
              <span v-if="searchTitItem.folder" class="blue">{{searchTitItem.folder}}</span>
              <span v-if="searchTitItem.from">{{$i18n.t('comm_lang_0007')}} "<span class="blue">{{searchTitItem.from}}</span>" </span>
              <span v-if="searchTitItem.to">{{$i18n.t('comm_lang_0008')}} "<span class="blue">{{searchTitItem.to}}</span>" </span>
              <span v-if="searchTitItem.subject">{{$i18n.t('comm_lang_0009')}} "<span class="blue">{{searchTitItem.subject}}</span>" </span>
              <span v-if="searchTitItem.attachName">{{$i18n.t('comm_lang_0010')}} "<span class="blue">{{searchTitItem.attachName}}</span>" </span>
              <span v-if="searchTitItem.startTime">{{$i18n.t('comm_lang_0011')}} "<span class="blue">{{searchTitItem.startTime}}</span>" {{$i18n.t('comm_lang_0012')}} "<span class="blue">{{searchTitItem.endTime}}</span>"</span>
              <span v-if="searchTitItem.attached">"<span class="blue">{{searchTitItem.attached}}</span>" </span>
              <span v-if="searchTitItem.seen">"<span class="blue">{{searchTitItem.seen}}</span>" </span>
              {{$i18n.t('comm_lang_0013')}}
              {{filterTitItem.seen ? filterTitItem.seen : ''}}
              {{filterTitItem.answered ? filterTitItem.answered : ''}}
              {{filterTitItem.forwarded ? filterTitItem.forwarded : ''}}
              {{filterTitItem.starred ? filterTitItem.starred : ''}}
              {{filterTitItem.attached ? filterTitItem.attached : ''}}
              {{filterTitItem.priority ? filterTitItem.priority : ''}}
              {{$i18n.t('comm_lang_0004')}}{{totalMailNums}}{{$i18n.t('comm_lang_0003')}}
            </span>
          </span>

          <span v-if="folderIsGarbage"> ({{$i18n.t('wm_lang_24e8a8')}}{{spamMailDeleteTime}}{{$i18n.t('comm_lang_0001')}}) <a v-if="indexInfoList" @click="deleteSpam" href="javascript:;">{{$i18n.t('comm_lang_0024')}}</a></span>

        </div>
      </div>
      <div class="nice_scroll contList">
        <!-- 循环数据-选中后ul标签上新增 selectBg CLASS；未星标图标点击后新增iconOn CLASS; 未读邮件咋标题和描述div上新增字体加粗fwb CLASS;列举了两条，第一条是选中的样式，第二条默认样式-->
        <!--<ul class="contListOne mailItem selectBg">-->
          <!--<li class="clear flexBetween">-->
             <!--<el-checkbox v-model="checked1"></el-checkbox>-->
             <!--<div class="nameTd cutout w152 mar f14 p0-p5 fwb" title="san.zhang@net263.com <san.zhang@net263.com>">{{$t("wm_lang_html_a42d13")}}</div>-->
             <!--<div class="rightAll"><i class="el-icon-paperclip"></i><span class="time">{{$t("wm_lang_html_2f8d6f")}} 11:55</span></div>-->
          <!--</li>-->
          <!--<li class="clear flexBetween" title="Re:Re: "+this.$i18n.t('wm_lang_7a311d')+"32"+this.$i18n.t('wm_lang_d87502')>-->
             <!--<div class="icon flexCenter replaced"><i class="el-icon-message-solid11" title=this.$i18n.t('wm_lang_894a10')></i></div>-->
             <!--<div class="listTd cutout w152 mar p0-p5 fwb">Re:Re: {{$t("wm_lang_html_7a311d")}}32{{$t("wm_lang_html_d87502")}}</div>-->
             <!--<p class="listIco"><i class="el-icon-time" title=this.$i18n.t('wm_lang_316206') @click="dialogFormVisible = true"></i><i class="el-icon-copy-document" title=this.$i18n.t('wm_lang_1e6021')></i><i class="el-icon-star-on iconOnYellow" title=this.$i18n.t('wm_lang_5abe91')></i></p>-->
          <!--</li>-->
        <!--</ul>-->
        <div class="f12 mt20 m15 w300" v-if="!indexInfoList || indexInfoList.length <= 0">
          <!--<span v-show="this.indexListStatus() !== 'searchStatus' && this.indexListStatus() === 'searchStatus'">{{$i18n.t('comm_lang_0016')}}</span>-->
          <span v-show="this.indexListStatus() === 'filterStatus'">
            {{$i18n.t('comm_lang_0018')}}
            <span style="font-weight: bold">
              {{filterTitItem.seen ? filterTitItem.seen : ''}}
              {{filterTitItem.answered ? filterTitItem.answered : ''}}
              {{filterTitItem.forwarded ? filterTitItem.forwarded : ''}}
              {{filterTitItem.starred ? filterTitItem.starred : ''}}
              {{filterTitItem.attached ? filterTitItem.attached : ''}}
              {{filterTitItem.priority ? filterTitItem.priority : ''}}
            </span>{{$i18n.t('comm_lang_0019')}}。
          </span>
          <span v-show="this.indexListStatus() === 'searchStatus'" class="cutout max298">{{$i18n.t('comm_lang_0020')}}</span>
        </div>
        <ul :class="checkedItem(item.mailIndexId) ? 'contListOne mailItem selectBg' : 'contListOne mailItem'" v-for="(item, index) in indexInfoList" :key="index" @click="clickReadMail(item)" @dblclick="dblclickReadMail(item)" @mouseover="overMailRow(item.mailIndexId)">
          <li class="clear flexBetween">
            <input type="checkbox" :checked="checkedItem(item.mailIndexId)" @click.stop="handleCheckedMailChange($event,item)" />
            <!--<input type="checkbox" :checked="checkedItem(item.id)" @change="handleCheckedMailChange($event,item.id)" @click="stopCheckedProp($event)" />-->
            <!--<el-checkbox :key="item.id" :checked="checkedItem(item.id)" @change="handleCheckedMailChange($event,item.id)" @click.native="stopCheckedProp($event)"></el-checkbox>-->
             <div v-if="!listShowFrom(item)" :class="item.seen === false ? 'nameTd cutout max-50auto mar f14 p0-p5 fwb' : 'nameTd cutout max-50auto mar f14 p0-p5'" :title="getListName(item)">{{getListName(item)}}</div>
             <div v-if="listShowFrom(item)" :class="item.seen === false ? 'nameTd cutout max-50auto mar f14 p0-p5 fwb' : 'nameTd cutout max-50auto mar f14 p0-p5'" :title="getListDraftName(item)">{{getListDraftName(item)}}</div>
             <div class="rightAll"><i class="el-icon-recall-new pr--2 mr3" :title="$i18n.t('comm_lang_0026')" v-if="isRecallMail(item.undoSend)"></i><i class="el-icon-paperclip" v-if="item.attachCount > 0"></i><span class="time">{{formatDate(item.receivedTime)}}</span></div>
          </li>
          <li class="clear flexBetween" :title="item.subject">
             <div class="icon flexCenter replaced mr3"><i class="el-icon-message-solid11" :title="$i18n.t('wm_lang_894a10')" v-if="item.seen === false"></i></div>
             <div :class="item.seen === false ? 'listTd cutout max-70auto mar pr5 fwb' : 'listTd cutout max-70auto mar pr5'" :title="item.subject ? item.subject : $i18n.t('wm_lang_3b239d')">
               <i class="el-icon-s-flag11 pr--2 mr3" :title="$i18n.t('wm_lang_cb0ed5')" style="color:#3986ee;" v-if="item.priority === 1"></i>
               <i class="el-icon-s-promotion11 pr--2 mr3" :title="$i18n.t('wm_lang_973732')" v-if="item.forwarded === true" style="color:#3986ee;"></i>
               <i class="el-icon-s-comment11 pr--2 mr3" :title="$i18n.t('wm_lang_4bea88')" v-if="item.answered === true" style="color:#3986ee;"></i>
               <i class="el-icon-time11 pr--2 mr3" :title="$i18n.t('custom_lang_0035')" v-if="isTimingMail(item.attrFlag)"></i>
               <span v-if="$store.state.folder.folderId === 64 || indexListStatus() === 'searchStatus' || homeAllUnread">[{{mailBelongFolder(item.folderId)}}]</span>
               {{item.subject ? item.subject : '('+$i18n.t('wm_lang_3b239d')+')'}}
             </div>
             <!--<p class="listIco"><i v-show="currOverMail === item.mailIndexId" class="el-icon-time" title=this.$i18n.t('wm_lang_316206')></i><i class="el-icon-copy-document" title=this.$i18n.t('wm_lang_1e6021') @click.stop="toNewReadMail(item)"></i><i @click.stop="indexMarkStar(item)" :class="item.starred === true ? 'el-icon-star-on iconOnYellow' : 'el-icon-star-on'" title=this.$i18n.t('wm_lang_5abe91')></i></p>-->
            <p class="listIco"><i class="el-icon-copy-document" :title="$i18n.t('wm_lang_1e6021')" @click.stop="toNewReadMail(item)"></i><i @click.stop="indexMarkStar(item)" :class="item.starred === true ? 'el-icon-star-on iconOnYellow' : 'el-icon-star-on'" title=""></i></p>
          </li>
        </ul>
        <!-- 无数据 -->
        <div v-if="!indexInfoList && this.indexListStatus() !== 'searchStatus' && this.indexListStatus() !== 'filterStatus'" class="f12 mt20 m15">{{$i18n.t('comm_lang_0016')}}</div>
        <div v-if="indexInfoList && indexInfoList.length === 0 && folderIsStar && this.indexListStatus() !== 'searchStatus' && this.indexListStatus() !== 'filterStatus'" class="f12 mt20 m15">{{$i18n.t('comm_lang_0017')}}</div>
        <!--<p class="p20" style="display:none;">{{$t("wm_lang_html_a34e49")}}</p>-->
      </div>

      <!-- 分页 -->
      <div class="listBarPag flexBetween">
      <!--<el-pagination-->
        <!--@size-change="handleSizeChange"-->
        <!--@current-change="handleCurrentChange"-->
        <!--:current-page.sync="currentPage2"-->
        <!--:page-sizes="[100, 200, 300, 400]"-->
        <!--:page-size="400"-->
        <!--layout="sizes, prev, next"-->
        <!--:total="1000">-->
      <!--</el-pagination>-->
        <el-dropdown size="medium" trigger="click" class="mr20" @command="handlePageTurn">
        <span class="el-dropdown-link">
          {{currentPage}}/{{totalPages}}{{$i18n.t('comm_lang_0014')}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
          <el-dropdown-menu slot="dropdown" style="max-height:150px;overflow:auto;" class="nice_scroll">
            <!--<el-dropdown-item class="active">1/5</el-dropdown-item>-->
            <el-dropdown-item :command="item.c" v-for="(item, index) in pageNumbers" :key="index">{{item.c}}/{{item.t}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-link :underline="false" @click="pageTurn('prev')"><i :class="getTurnPrevFlag() ? 'el-icon-arrow-left mr10 f18 disabled' : 'el-icon-arrow-left mr10 f18'"></i></el-link>
        <el-link :underline="false" @click="pageTurn('next')"><i :class="getTurnNextFlag() ? 'el-icon-arrow-right mr10 f18 disabled' : 'el-icon-arrow-right mr10 f18'"></i></el-link>
      </div>

      <!-- 设置待办模态框 -->
      <el-dialog :title="$i18n.t('wm_lang_316206')" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="36%">
        <el-form :model="form">
          <el-form-item :label="$i18n.t('wm_lang_1501d5')" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off" :placeholder="$i18n.t('wm_lang_9365f3')" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_0c0335')" :label-width="formLabelWidth">
            <el-col :span="11">
              <el-date-picker type="date" :placeholder="$i18n.t('wm_lang_2bebdd')" v-model="form.date1" style="width: 100%;"></el-date-picker>
            </el-col>
            <el-col class="tc" :span="2">-</el-col>
            <el-col :span="11">
              <el-time-select :placeholder="$i18n.t('wm_lang_2c825a')" v-model="form.date2" :picker-options="{ start: '00:00', step: '00:30', end: '23:30', minTime: date2 }" style="width: 100%;"></el-time-select>
            </el-col>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_e6df5b')" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="form.desc"></el-input>
            <el-checkbox v-model="checkedTb">{{$t("wm_lang_html_f952f5")}}</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>

  <!-- 拖拽拉伸按钮 -->
  <dragHolder @widthChange="dragWidthChange" />
  <!--<div id="drag" ref="dragHolder" class="enabl">-->
			<!--<div class="contListWid">-->
				<!--<p style="background-color: yellow;"><span></span><span></span><span></span></p>-->
			<!--</div>-->
	 <!--</div>-->

  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import xmail from '@/api/api';
  import storeLocal from 'store';
  import { bytesToSize, formatDate, emailPart, belongRootFolderId } from '@/utils/utils';
  import dragHolder from "@/components/sub/dragHolder";
export default {
  name: 'listBar',
  data () {
    return {
      // indexInfoList: this.$store.getters.indexListData.length === 0 ? this.$store.getters.indexListData : [],
      localConfigSetting: '',
      indexInfoList: this.$store.getters.indexListData && this.$store.getters.indexListData.length !== 0 ? this.$store.getters.indexListData : [],
      msgindex: this.$i18n.t('wm_lang_6b0fd2'),
      // currentPage2: 5,
      configSetting: storeLocal.get('Pwm-configSetting') ? storeLocal.get('Pwm-configSetting') : {},
      currOverMail: '',
      unreadMailNums: 0,
      totalMailNums: 0,
      currentPage: 1,
      totalPages: 1,
      pageNumbers: [],
      checked1: true,
      checkedTb: true,
      status: false,
      date2: '',
      layoutType: Cookies.get('Pwm-set-layout') ? Cookies.get('Pwm-set-layout') : 'lr',
      // 设置待办
      dialogFormVisible: false,
      form: {
        name: '',
        date1: '',
        desc: ''
      },
      formLabelWidth: '80px',
      tableData: [{
        date: '02-15 15:32',
        capacity: '50K',
        name: this.$i18n.t('wm_lang_7a427c'),
        readText: this.$i18n.t('wm_lang_29d09a')+' 1518 '+this.$i18n.t('wm_lang_d47c7f')
      }, {
        date: '02-15 15:32',
        capacity: '100K',
        name: 'pm-gensee@net263.com',
        readText: this.$i18n.t('wm_lang_41e17a')+'/'+this.$i18n.t('wm_lang_12f1d7')+'/'+this.$i18n.t('wm_lang_19cd24')+'/CC brocker'+this.$i18n.t('wm_lang_ef0b42')+'/CC brocker'+this.$i18n.t('wm_lang_ef0b42')+'/'+this.$i18n.t('wm_lang_60eec8')+'/2022-02-15_22:30'
      }],
      multipleSelection: [],
      filterTitItem: {},
      searchTitItem: {},
      readMailTimer: null,
      mailIndexParamRecord: {},
      homeAllUnread: false,
      dragWidth: 330,
      spamMailDeleteTime: 15
    }
  },
  components: {
    dragHolder
  },
  methods: {
    dragWidthChange(moveDistance) {
      this.dragWidth -= moveDistance;
      if (this.dragWidth < 300) {
        this.dragWidth = 300;
      }
      if (this.dragWidth > 680) {
        this.dragWidth = 680;
      }
    },
    isTimingMail(attrFlag) {
      return (attrFlag & xmail.flags.MailIndexAttrFlag.SENDLATER_VAL) !== 0
    },
    isRecallMail(undoSend) {
      return undoSend !== xmail.enums.MailUndoSendType.NO_UNDO && undoSend !== xmail.enums.MailUndoSendType.UNKNOWN
    },
    deleteSpam() {
      let loading = this.$loading({text: this.$i18n.t('wm_lang_f8de3d')});
      this.$confirm(this.$i18n.t('wm_lang_f9d94b'), this.$i18n.t('wm_lang_c45357'), {
        confirmButtonText: this.$i18n.t('wm_lang_38cf16'),
        cancelButtonText: this.$i18n.t('wm_lang_625fb2'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        let self = this;
        (function (api, enums, pms) {
          let pm = pms.Folder.cleanFolderParamBuilder();
          pm.folderId = enums.FolderType.GARBAGE_MAIL_BOX_FOLDER_ID;
          api.Folder.cleanFolder(pm, function (res) {
            self.$store.commit('SET_CHECKED_MAILS',[]);
            self.$EventBus.$emit("getCurrFid",{folderId: self.$store.getters.folderId});
            self.$EventBus.$emit("refreshFolders");
            loading.close();
            self.$message({
              type: 'success',
              message: self.$i18n.t('wm_lang_0007d1')+'!'
            });
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }).catch(() => {
        loading.close();
      });
    },
    listShowFrom(item) {
      let itemFolderId = belongRootFolderId(item.folderId, this.$store.getters.folders);
      return itemFolderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID || itemFolderId === xmail.enums.FolderType.SEND_BOX_FOLDER_ID
    },
    mailBelongFolder(fid) {
      // console.log(fid);
      // console.log(this.$store.getters.folders);
      // console.log(this.$store.state.folder.folderId);
      let folders = this.$store.getters.folders;
      let folder = '';
      folder = folders.find(item => item.folderId === fid);
      return folder ? folder.displayName : '';
    },
    queryUnread() {
      this.mailIndexList({id: this.$store.getters.folderId, filterType: 'unread'});
    },
    changeToRead() {
      // console.log(this.$store.getters.folderId);
      let self = this;
      if(!this.homeAllUnread) {
        (function (api, enums, pms) {
          let pm = pms.Index.batchSetMailStatusParamBuilder();
          pm.folderId = self.$store.getters.folderId;
          pm.targetMailStatus = xmail.enums.MailStatus.READ;
          // console.log(pm)
          // return;
          api.Index.batchSetMailStatus(pm, function (res) {
            if(res.data.code === 0) {
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_33130f')
              });
              self.$EventBus.$emit("refreshFolders");
              self.mailIndexList({id: self.$store.state.folder.folderId});
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      } else {
        (function (api, enums, pms) {
          let mailIds = self.$store.getters.indexListData.map(item =>{return item.mailIndexId});
          let pm = pms.Index.setMailStatusParamBuilder();
          pm.mailIndexIds = mailIds;
          pm.targetMailStatus = xmail.enums.MailStatus.READ;
          // console.log(pm)
          // return;
          api.Index.setMailStatus(pm, function (res) {
            if(res.data.code === 0) {
              self.$message({
                type: 'success',
                message: self.$i18n.t('wm_lang_33130f')
              });
              self.$EventBus.$emit("refreshFolders");
              self.mailIndexList({filterType: 'unread'});
            }
          })
        })(xmail.api, xmail.enums, xmail.pms);
      }
    },
    getFolderName() {
      return this.$store.getters.folderName ? this.$store.getters.folderName : this.$i18n.t('wm_lang_e75969')
    },
    bytesToSize(bytes) {
      return bytesToSize(bytes)
    },
    formatDate(val) {
      return formatDate(val)
    },
    getTurnPrevFlag() {
      let flag = false;
      if(this.currentPage === 1){
        flag = true
      }
      return flag
    },
    getTurnNextFlag() {
      let flag = false;
      if(this.currentPage === this.totalPages){
        flag = true
      }
      return flag
    },
    pageTurn(page) {
      if(page === 'next'){
        if(this.getTurnNextFlag()){
          return
        }
        this.currentPage = this.currentPage+1
      } else if(page === 'prev') {
        if(this.getTurnPrevFlag()){
          return
        }
        this.currentPage = this.currentPage-1
      } else {
        this.currentPage = page
      }

      let indexListStatus = this.indexListStatus();
      if(indexListStatus) {
        this.mailIndexList({keepParams: true});
      } else {
        this.mailIndexList({id: this.$store.state.folder.folderId});
      }
    },
    handlePageTurn(command) {
      this.currentPage = command;
      let indexListStatus = this.indexListStatus();
      // this.mailIndexList({id: this.$store.state.folder.folderId});
      if(indexListStatus) {
        this.mailIndexList({keepParams: true});
      } else {
        this.mailIndexList({id: this.$store.state.folder.folderId});
      }
    },
    indexListStatus() {
      let liststatus = '';
      if(this.mailIndexParamRecord.mailIndexFilter && Object.keys(this.mailIndexParamRecord.mailIndexFilter).length !== 0) {
        liststatus = 'filterStatus';
      }
      if(this.mailIndexParamRecord.mailIndexQuery && Object.keys(this.mailIndexParamRecord.mailIndexQuery).length !== 0) {
        liststatus = 'searchStatus';
      }
      // if(this.mailIndexParamRecord.mailIndexFilter
      //   && Object.keys(this.mailIndexParamRecord.mailIndexFilter).length !== 0
      //   && this.mailIndexParamRecord.mailIndexQuery
      //   && Object.keys(this.mailIndexParamRecord.mailIndexQuery).length !== 0 ) {
      //   liststatus = 'filterSearchStatus';
      // }
      return liststatus;
    },
    handleCheckedMailChange(e, item, isTableLayout) {
      // let checkedCount = value.length;
      let chkMails = this.$store.getters.checkedMails;
      // console.log(chkMails);
      //取消跨域全选
      this.$store.commit('SET_ACROSS_COUNT', 0);
      this.$store.commit('SET_ACROSS_FLAG', false);
      if(e.target.checked){
        // chkMails.push({emailId: item.mailIndexId, folderId: item.folderId});
        chkMails.push(item);
        if(chkMails.length < 2){
          // console.log(item);
          if(!isTableLayout) {
            this.toReadMail(item);
          }
        }
        if(this.totalPages === 1) {
          if(this.indexInfoList.length < this.configSetting.displaySetting.pageSize) {
            this.$EventBus.$emit("listCheckAll", this.indexInfoList.length === chkMails.length);
          }
        } else {
          this.$EventBus.$emit("cancelListCheckAll", this.configSetting.displaySetting.pageSize === chkMails.length);
        }
      } else {
        chkMails.splice(chkMails.findIndex(ite => ite.mailIndexId === item.mailIndexId), 1)
        if(chkMails.length === 1){
          if(!isTableLayout) {
            this.toReadMail(chkMails[0]);
          }
        }
        this.$EventBus.$emit("cancelListCheckAll");
      }
      // console.log(chkMails);
      // this.$store.commit('SET_CHECKED_MAILS',chkMails);
    },
    indexMarkStar(mail) {
      let self = this;
      let mailId = mail.mailIndexId;
      let mailStar = mail.starred;
      // let mItem = {emailId: mail.mailIndexId, folderId: mail.folderId};
      (function (api, enums, pms) {
        let spm = pms.Index.setMailStatusParamBuilder();
        // spm.mailItems = [mItem];
        spm.mailIndexIds = [mail.mailIndexId];
        let opType = '';
        let opTypeVal = false;
        if(mailStar === false) {
          opType = enums.MailStatus.STAR;
          opTypeVal = true;
        }
        if(mailStar === true) {
          opType = enums.MailStatus.DE_STAR;
          opTypeVal = false;
        }
        spm.targetMailStatus = opType;
        api.Index.setMailStatus(spm, function (res) {
          // console.log(res)
          let indexList = self.$store.getters.indexListData;
          let newList = indexList.map((item) => {
            if(mailId === item.mailIndexId){
              // console.log(item.id)
              item.starred = opTypeVal
            }
            return item
          })
          self.$store.commit('SET_INDEX_DATA',newList);
          if(res.data.code === 0){
            // self.$message(this.$i18n.t('wm_lang_2f293a'));
            self.$EventBus.$emit("refreshFolders");
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
    },
    overMailRow(id) {
      // console.log(id)
      this.currOverMail = id;
    },
    // handleCheckedMailChangeTable(selection, row) {
    //   let selected = selection.length && selection.indexOf(row) !== -1 // true就是选中，0或者false是取消选中
    //   let chkMails = this.$store.getters.checkedMails;
    //   if(selected){
    //     chkMails.push(row.id);
    //   } else {
    //     chkMails.splice(chkMails.findIndex(item => item === row.id), 1)
    //   }
    //   this.$store.commit('SET_CHECKED_MAILS',chkMails)
    // },
    // 分页
    // handleSizeChange(val) {
    //   console.log(`每页 ${val} 条`);
    // },
    // handleCurrentChange(val) {
    //   console.log(`当前页: ${val}`);
    // },
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    //   console.log(this.multipleSelection)
    // },
    // stopCheckedProp(e) {
    //   e.stopPropagation();
    // },
    checkedItem(id){
      let chkMails = this.$store.getters.checkedMails;
      let chkMailsIds = chkMails.map(obj => {return obj.mailIndexId})
      // console.log(chkMails)
      // console.log(chkMailsIds)
      return chkMailsIds.includes(id);
    },
    clickReadMail(item) {
      clearTimeout(this.readMailTimer);
      let self = this;
      this.readMailTimer = setTimeout(function () {
        self.toReadMail(item);
      }, 300)
    },
    dblclickReadMail(item) {
      clearTimeout(this.readMailTimer);
      this.toNewReadMail(item);
    },
    toReadMail(item) {
      // console.log(item);
      this.$store.commit('SET_CHECKED_MAILS',[]) //点击读信清空复选索引
      let chkMails = this.$store.getters.checkedMails;
      // chkMails.push({emailId: item.mailIndexId, folderId: item.folderId});
      chkMails.push(item);
      this.$store.commit('SET_CHECKED_MAILS',chkMails);
      // this.$router.push({path:'/MainHome/boxMail/readMail',query: {id:id}})
      this.$router.push({name:'read',params: {id:item.mailIndexId, fileId:item.fileId, folderId: item.folderId, read:item.seen},query: { t: Date.now() }})
    },
    toNewReadMail(item) {
      // console.log(item);
      this.$store.commit('SET_CHECKED_MAILS',[]);
      let chkMails = this.$store.getters.checkedMails;
      // chkMails.push({emailId: item.mailIndexId, folderId: item.folderId});
      chkMails.push(item);
      // console.log(chkMails);
      this.$store.commit('SET_CHECKED_MAILS',chkMails);
      // 草稿跳转写信页签编辑
      let itemFolderId = belongRootFolderId(item.folderId, this.$store.getters.folders);
      if(itemFolderId === xmail.enums.FolderType.DRAFT_BOX_FOLDER_ID) {
        // let mid = this.$route.params.id;
        this.$router.push({name: 'write', params: {type: 'draft', folderId: item.folderId, fileId:item.fileId, mid: item.mailIndexId}});
        return;
      }
      this.$router.push({name: 'newRead', params: {id:item.mailIndexId, fileId:item.fileId, folderId: item.folderId, read:item.seen, tit:item.subject},query: { t: Date.now() }});
    },
    // toNewReadMailTable(row) {
    //   this.$refs.multipleTable.toggleRowSelection(row, true);
    //   let chkMails = this.$store.getters.checkedMails;
    //   if(!chkMails.includes(row.id)){
    //     chkMails.push(row.id);
    //   }
    //   this.$store.commit('SET_CHECKED_MAILS',chkMails);
    //   this.$router.push({name: 'newRead', params: {id:row.id, tit:row.title},query: { t: Date.now() }});
    // },
    makePageNumbers(total) {
      let pNumbers = [];
      for(let i=0; i<total; i++){
        let item = {c: i+1, t: total}
        pNumbers.push(item);
      }
      return pNumbers;
    },
    /**
     * 生成邮件索引
     * @method
     * @param {indexObject.id} 文件夹ID
     * @param {indexObject.filterType} 索引筛选类型
     * @param {indexObject.searchInfo} 邮件搜索信息对象
     * @return {无}
     **/
    mailIndexList(indexObject) {
      let self = this;
      self.$store.commit('SET_CHECKED_MAILS',[]);
      // console.log(self.listTilteStatus);
      // let indexId = id !== undefined ? id : 1;
      let fid = indexObject.id;
      (function (api, enums, pms) {
        let ipm = pms.Index.getIndexListParamBuilder();
        console.log(indexObject);
        console.log(indexObject.keepParams);
        if(indexObject.keepParams) {
          // self.$store.commit('SET_CHECKED_MAILS',[]);
          console.log(self.mailIndexParamRecord);
          // indexObject = {indexObject,...self.mailIndexParamRecord.indexObject};
          // indexObject = self.mailIndexParamRecord.indexObject;
          ipm.pageSize = self.configSetting.displaySetting.pageSize ? self.configSetting.displaySetting.pageSize : 20;
          // if(self.mailIndexParamRecord.currentPage) {
          //   self.currentPage = self.mailIndexParamRecord.currentPage;
          // }
          ipm.currentPage = self.currentPage;
          if(self.mailIndexParamRecord.folderId) {
            ipm.folderId = self.mailIndexParamRecord.folderId;
          }
          if(self.mailIndexParamRecord.mailIndexQuery && Object.keys(self.mailIndexParamRecord.mailIndexQuery).length !== 0) {
          // if(self.mailIndexParamRecord.mailIndexQuery) {
            ipm.mailIndexQueryParam = self.mailIndexParamRecord.mailIndexQuery;
          }
          if(self.mailIndexParamRecord.mailIndexFilter && Object.keys(self.mailIndexParamRecord.mailIndexFilter).length !== 0) {
          // if(self.mailIndexParamRecord.mailIndexFilter) {
             ipm.mailIndexFilterParam = self.mailIndexParamRecord.mailIndexFilter;
          }

          if(self.mailIndexParamRecord.mailIndexSort && Object.keys(self.mailIndexParamRecord.mailIndexSort).length !== 0) {
            // if(self.mailIndexParamRecord.mailIndexSort) {
            ipm.mailIndexSortParam = self.mailIndexParamRecord.mailIndexSort;
          }

        } else {
          ipm.currentPage = self.currentPage;
          if(fid) {
            ipm.folderId = fid;
          }
          ipm.pageSize = self.configSetting.displaySetting.pageSize ? self.configSetting.displaySetting.pageSize : 20;
          // ipm.mailIndexSortParam = new pms.MailIndexSortParam();
          // ipm.mailIndexSortParam.timeSortType = 1;

          switch (indexObject.filterType) {
            case 'all':
              console.log('all');
              // ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              // ipm.mailIndexSortParam.timeSortType = enums.SortType.DESC;
              break;
            case 'unread':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.seen = false;
              break;
            case 'read':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.seen = true;
              break;
            case 'reply':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.answered = true;
              break;
            case 'forward':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.forwarded = true;
              break;
            case 'recallAll':
              console.log('recallAll')
              break;
            case 'recallPart':
              console.log('recallPart')
              break;
            case 'star':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.starred = true;
              break;
            case 'unstar':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.starred = false;
              break;
            case 'attach':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.attached = true;
              break;
            case 'noattach':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.attached = false;
              break;
            case 'priorityUrgency':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.priority = enums.MailPriority.URGENCY
              break;
            case 'priorityNormal':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.priority = enums.MailPriority.NORMAL;
              break;
            case 'prioritySlow':
              ipm.mailIndexFilterParam = new pms.MailIndexFilterParam();
              ipm.mailIndexFilterParam.priority = enums.MailPriority.SLOW;
              break;
            case 'timeAsc':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.timeSortType = enums.SortType.ASC;
              break;
            case 'timeDes':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.timeSortType = enums.SortType.DESC;
              break;
            case 'senderDes':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.senderSortType = enums.SortType.DESC;
              break;
            case 'senderAsc':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.senderSortType = enums.SortType.ASC;
              break;
            case 'subjectDes':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.subjectSortType = enums.SortType.DESC;
              break;
            case 'subjectAsc':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.subjectSortType = enums.SortType.ASC;
              break;
            case 'sizeDes':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.mailSizeSortType = enums.SortType.DESC;
              break;
            case 'sizeAsc':
              ipm.mailIndexSortParam = new pms.MailIndexSortParam();
              ipm.mailIndexSortParam.mailSizeSortType = enums.SortType.ASC;
              break;
          }

          if(indexObject.searchInfo) {
            switch (indexObject.searchInfo.scope) {
              case 'all':
                ipm.mailIndexQueryParam = new pms.MailIndexQueryParam();
                ipm.mailIndexQueryParam.searchType = 'QUICK';
                ipm.mailIndexQueryParam.from = indexObject.searchInfo.key;
                ipm.mailIndexQueryParam.to = indexObject.searchInfo.key;
                ipm.mailIndexQueryParam.subject = indexObject.searchInfo.key;
                ipm.mailIndexQueryParam.attachName = indexObject.searchInfo.key;
                // ipm.mailIndexQueryParam.fullText = indexObject.searchInfo.key;
                break;
              case 'sender':
                ipm.mailIndexQueryParam = new pms.MailIndexQueryParam();
                ipm.mailIndexQueryParam.searchType = 'QUICK';
                ipm.mailIndexQueryParam.from = indexObject.searchInfo.key;
                break;
              case 'topic':
                ipm.mailIndexQueryParam = new pms.MailIndexQueryParam();
                ipm.mailIndexQueryParam.searchType = 'QUICK';
                ipm.mailIndexQueryParam.subject = indexObject.searchInfo.key;
                break;
              case 'receiver':
                ipm.mailIndexQueryParam = new pms.MailIndexQueryParam();
                ipm.mailIndexQueryParam.searchType = 'QUICK';
                ipm.mailIndexQueryParam.to = indexObject.searchInfo.key;
                break;
              // case 'text':
              //   ipm.mailIndexQueryParam = new pms.MailIndexQueryParam();
              //   ipm.mailIndexQueryParam.searchType = 'QUICK';
              //   ipm.mailIndexQueryParam.fullText = indexObject.searchInfo.key;
              //   break;
              case 'attach':
                ipm.mailIndexQueryParam = new pms.MailIndexQueryParam();
                ipm.mailIndexQueryParam.searchType = 'QUICK';
                ipm.mailIndexQueryParam.attachName = indexObject.searchInfo.key;
                break;
              case 'advanced':
                // console.log(indexObject.searchInfo.keyObj)
                ipm.mailIndexQueryParam = new pms.MailIndexQueryParam();
                ipm.mailIndexQueryParam.searchType = 'ADVANCED';
                if(indexObject.searchInfo.keyObj.searchFolder) {
                  ipm.folderId = indexObject.searchInfo.keyObj.searchFolder;
                }
                if(indexObject.searchInfo.keyObj.sender) {
                  ipm.mailIndexQueryParam.from = indexObject.searchInfo.keyObj.sender;
                }
                if(indexObject.searchInfo.keyObj.receiver) {
                  ipm.mailIndexQueryParam.to = indexObject.searchInfo.keyObj.receiver;
                }
                if(indexObject.searchInfo.keyObj.topic) {
                  ipm.mailIndexQueryParam.subject = indexObject.searchInfo.keyObj.topic;
                }
                if(indexObject.searchInfo.keyObj.attachName) {
                  ipm.mailIndexQueryParam.attachName = indexObject.searchInfo.keyObj.attachName;
                }
                if(indexObject.searchInfo.keyObj.selectAttach && indexObject.searchInfo.keyObj.selectAttach !== '1') {
                  if(indexObject.searchInfo.keyObj.selectAttach === '2' ) {
                    ipm.mailIndexQueryParam.attached = true;
                  }
                  if(indexObject.searchInfo.keyObj.selectAttach === '3' ) {
                    ipm.mailIndexQueryParam.attached = false;
                  }
                }
                if(indexObject.searchInfo.keyObj.selectStatus && indexObject.searchInfo.keyObj.selectStatus !== '1') {
                  if(indexObject.searchInfo.keyObj.selectStatus === '2' ) {
                    ipm.mailIndexQueryParam.seen = true;
                  }
                  if(indexObject.searchInfo.keyObj.selectStatus === '3' ) {
                    ipm.mailIndexQueryParam.seen = false;
                  }
                }
                if(indexObject.searchInfo.keyObj.timeSpans) {
                  ipm.mailIndexQueryParam.startTime = indexObject.searchInfo.keyObj.timeSpans[0];
                  ipm.mailIndexQueryParam.endTime = indexObject.searchInfo.keyObj.timeSpans[1];
                }
                break;
            }
          }

          console.log(indexObject.sortType);
          if(indexObject.sortType) {
            if(self.mailIndexParamRecord.mailIndexFilter && Object.keys(self.mailIndexParamRecord.mailIndexFilter).length !== 0) {
              ipm.mailIndexFilterParam = self.mailIndexParamRecord.mailIndexFilter;
            }
            if(self.mailIndexParamRecord.mailIndexQuery && Object.keys(self.mailIndexParamRecord.mailIndexQuery).length !== 0) {
              ipm.mailIndexQueryParam = self.mailIndexParamRecord.mailIndexQuery;
            }
          } else {
            if(self.mailIndexParamRecord.mailIndexSort && Object.keys(self.mailIndexParamRecord.mailIndexSort).length !== 0) {
              ipm.mailIndexSortParam = ipm.mailIndexSortParam ? ipm.mailIndexSortParam : self.mailIndexParamRecord.mailIndexSort;
            }
          }

          if(indexObject.searchStatusType) {
            // console.log(indexObject);
            if(self.mailIndexParamRecord.mailIndexFilter && Object.keys(self.mailIndexParamRecord.mailIndexFilter).length !== 0) {
              if(indexObject.filterType !== 'all') {
                ipm.mailIndexFilterParam = ipm.mailIndexFilterParam ? ipm.mailIndexFilterParam : self.mailIndexParamRecord.mailIndexFilter;
              }
            }
            if(self.mailIndexParamRecord.mailIndexQuery && Object.keys(self.mailIndexParamRecord.mailIndexQuery).length !== 0) {
              ipm.mailIndexQueryParam = ipm.mailIndexQueryParam ? ipm.mailIndexQueryParam : self.mailIndexParamRecord.mailIndexQuery;
            }
          }

        }


        //邮件列表请求参数记录
        console.log(indexObject);
        console.log(ipm);
        if(indexObject) {
          self.mailIndexParamRecord.indexObject = indexObject;
        }
        if(ipm.currentPage) {
          self.mailIndexParamRecord.currentPage = ipm.currentPage;
        } else {
          self.mailIndexParamRecord.currentPage = 1;
        }
        if(ipm.folderId) {
          self.mailIndexParamRecord.folderId = ipm.folderId;
        } else {
          self.mailIndexParamRecord.folderId = '';
        }
        // if(ipm.mailIndexQueryParam && Object.keys(ipm.mailIndexQueryParam).length !== 0) {
        //   self.mailIndexParamRecord.mailIndexQuery = ipm.mailIndexQueryParam;
        // } else {
        //   if(!indexObject.filterType) { //邮件搜索下筛选
        //     self.mailIndexParamRecord.mailIndexQuery = {};
        //   }
        // }
        if(ipm.mailIndexQueryParam && Object.keys(ipm.mailIndexQueryParam).length !== 0) {
          self.mailIndexParamRecord.mailIndexQuery = ipm.mailIndexQueryParam;
        } else {
          self.mailIndexParamRecord.mailIndexQuery = {};
        }
        if(ipm.mailIndexFilterParam && Object.keys(ipm.mailIndexFilterParam).length !== 0) {
          self.mailIndexParamRecord.mailIndexFilter = ipm.mailIndexFilterParam;
        } else {
          self.mailIndexParamRecord.mailIndexFilter = {};
        }
        if(ipm.mailIndexSortParam && Object.keys(ipm.mailIndexSortParam).length !== 0) {
          self.mailIndexParamRecord.mailIndexSort = ipm.mailIndexSortParam;
        } else {
          self.mailIndexParamRecord.mailIndexSort = {};
        }
        console.log(self.mailIndexParamRecord);

        console.log(indexObject);


        //构建邮件索引Title
        self.setIndexListTitle(ipm);

        if(ipm.mailIndexQueryParam && Object.keys(ipm.mailIndexQueryParam).length !== 0){
          self.$store.commit('SET_FOLDER_ID','');
        }

        let loading = self.$loading({text: self.$i18n.t('wm_lang_f013ea'), target: document.querySelector('.wmCloudsBox')});
        // console.log(ipm)
        // return;
        api.Index.getIndexList(ipm, function (res) {
          const data = res.data;
          // console.log(data)
          if(data.code === 0) {
            self.indexInfoList = data.data.mailIndexPage.records;
            self.$store.commit('SET_INDEX_DATA',data.data.mailIndexPage.records);
            if(self.$store.getters.acrossSelectCount !== 0) {
              self.$store.commit('SET_CHECKED_MAILS', data.data.mailIndexPage.records);
              self.$store.commit('SET_ACROSS_FLAG', true);
              self.$EventBus.$emit("cancelListCheckAll", true);
            }
            self.$store.commit('SET_INDEXLIST_PARAMS',ipm);
            self.totalPages = data.data.mailIndexPage.pages !== 0 ? data.data.mailIndexPage.pages : 1;
            self.pageNumbers = self.makePageNumbers(data.data.mailIndexPage.pages);
            // self.unreadMailNums = data.data.mailIndexPage.newMailCount;
            if(data.data.mailFolder) {
              self.unreadMailNums = data.data.mailFolder.unseenCount;
            } else {
              self.unreadMailNums = 0;
            }
            self.totalMailNums = data.data.mailIndexPage.total;
            self.$EventBus.$emit("setAcrossPageData",{pages:data.data.mailIndexPage.pages, pageSize:data.data.mailIndexPage.size, total: data.data.mailIndexPage.total});
          }
          loading.close();
        })
      })(xmail.api, xmail.enums, xmail.pms);
      //重置索引列表排序
      self.$EventBus.$emit("resetListSortType");
      self.$EventBus.$emit("cancelListCheckAll");
    },
    // getFilterType(filterPm) {
    //   let fType = '',
    //       key = Object.keys(filterPm)[0],
    //       val = Object.values(filterPm)[0];
    //   if(key === 'seen') {
    //     fType = val ? 'read' : 'unread';
    //   }
    //   if(key === 'answered') {
    //     fType = val ? 'reply' : 'all';
    //   }
    //   if(key === 'forwarded') {
    //     fType = val ? 'forward' : 'all';
    //   }
    //   if(key === 'starred') {
    //     fType = val ? 'star' : 'unstar';
    //   }
    //   if(key === 'attach') {
    //     fType = val ? 'attach' : 'noattach';
    //   }
    //   return fType;
    // },
    setIndexListTitle(listPm) {
      // console.log(listPm);
      // console.log(this.$store.getters.folders);
      let filterTitScope = {},
          searchTitScope = {};
      if(listPm.folderId) {
        let folder = this.$store.getters.folders.find(item => {
          return item.folderId === listPm.folderId;
        });
        searchTitScope.folder = folder ? folder.displayName : '';
      }
      if(listPm.mailIndexQueryParam) {
        if(listPm.mailIndexQueryParam.from !== undefined) {
          searchTitScope.from = listPm.mailIndexQueryParam.from
        }
        if(listPm.mailIndexQueryParam.to !== undefined) {
          searchTitScope.to = listPm.mailIndexQueryParam.to
        }
        if(listPm.mailIndexQueryParam.subject !== undefined) {
          searchTitScope.subject = listPm.mailIndexQueryParam.subject
        }
        if(listPm.mailIndexQueryParam.attachName !== undefined) {
          searchTitScope.attachName = listPm.mailIndexQueryParam.attachName
        }
        if(listPm.mailIndexQueryParam.startTime !== undefined) {
          searchTitScope.startTime = this.$moment(listPm.mailIndexQueryParam.startTime).format('YYYY-MM-DD HH:mm:ss');
        }
        if(listPm.mailIndexQueryParam.endTime !== undefined) {
          searchTitScope.endTime = this.$moment(listPm.mailIndexQueryParam.endTime).format('YYYY-MM-DD HH:mm:ss');
        }
        if(listPm.mailIndexQueryParam.attached !== undefined) {
          searchTitScope.attached = listPm.mailIndexQueryParam.attached ? this.$i18n.t('wm_lang_60ae02') : this.$i18n.t('wm_lang_953b40');
        }
        if(listPm.mailIndexQueryParam.seen !== undefined) {
          searchTitScope.seen = listPm.mailIndexQueryParam.seen ? this.$i18n.t('wm_lang_8ad629') : this.$i18n.t('wm_lang_894a10');
        }
      }
      if(listPm.mailIndexFilterParam) {
        if(listPm.mailIndexFilterParam.seen !== undefined) {
          console.log(listPm.mailIndexFilterParam.seen);
          filterTitScope.seen = listPm.mailIndexFilterParam.seen ? this.$i18n.t('wm_lang_8ad629') : this.$i18n.t('wm_lang_894a10');
          filterTitScope.unreadFlag = !listPm.mailIndexFilterParam.seen;
        }
        if(listPm.mailIndexFilterParam.answered !== undefined) {
          filterTitScope.answered = listPm.mailIndexFilterParam.answered ? this.$i18n.t('wm_lang_4bea88') : this.$i18n.t('wm_lang_6231a2');
        }
        if(listPm.mailIndexFilterParam.forwarded !== undefined) {
          filterTitScope.forwarded = listPm.mailIndexFilterParam.forwarded ? this.$i18n.t('wm_lang_973732') : this.$i18n.t('wm_lang_a5ff1b');
        }
        if(listPm.mailIndexFilterParam.starred !== undefined) {
          filterTitScope.seen = listPm.mailIndexFilterParam.seen ? this.$i18n.t('wm_lang_2f293a') : this.$i18n.t('wm_lang_5abe91');
        }
        if(listPm.mailIndexFilterParam.attached !== undefined) {
          filterTitScope.attached = listPm.mailIndexFilterParam.attached ? this.$i18n.t('wm_lang_60ae02') : this.$i18n.t('wm_lang_953b40');
        }
        if(listPm.mailIndexFilterParam.priority !== undefined) {
          switch (listPm.mailIndexFilterParam.priority) {
            case 1:
              filterTitScope.priority = this.$i18n.t('wm_lang_cb0ed5');
              break;
            case 3:
              filterTitScope.priority = this.$i18n.t('wm_lang_35242c');
              break;
            case 5:
              filterTitScope.priority = this.$i18n.t('wm_lang_1efeae');
              break;
          }
        }
      }
      this.filterTitItem = filterTitScope;
      this.searchTitItem = searchTitScope;
    },
    getListDraftName(mail) {
      // console.log(mail)
      if(mail.mailTo) {
        let toArr = mail.mailTo.split('¶');
        let listDraftNameArr = [];
        toArr.forEach(item => {
          listDraftNameArr.push(item.split('<')[0]);
        });
        // console.log(listDraftNameArr)
        return listDraftNameArr.join(',');
      } else {
        return '('+this.$i18n.t('wm_lang_5c6881')+')';
      }
    },
    getListName(listItem) {
      let persInfoEmails = storeLocal.get('ls_pers_info').map(item => {
        if(item.email !== ''){
          return item;
        }
      });
      persInfoEmails = persInfoEmails.filter(item => {return item}); //{{$t("wm_lang_html_b3b1f7")}}undefined
      let persInfoArr = [];
      persInfoEmails.forEach(item => {
        persInfoArr.push([item.email, item.name]);
      });
      let persInfoMap = new Map(persInfoArr);
      let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
      if(storeRootFolderId !== xmail.enums.FolderType.SEND_BOX_FOLDER_ID) {
        //收信时姓名显示
        let mailFromName = emailPart(listItem.mailFrom, 'name');
        let mailFromEmail = emailPart(listItem.mailFrom, 'email');
        // console.log(mailFromName);
        // console.log(mailFromEmail);
        if(this.localConfigSetting.displaySetting.recvFromDisplay === xmail.enums.RecvFromDisplayType.CONTACT) {
          /*
          let persInfoEmails = storeLocal.get('ls_pers_info').map(item => {
            if(item.email !== ''){
              return item;
            }
          });
          persInfoEmails = persInfoEmails.filter(item => {return item}); //{{$t("wm_lang_html_b3b1f7")}}undefined
          let persInfoArr = [];
          persInfoEmails.forEach(item => {
            persInfoArr.push([item.email, item.name]);
          });
          let persInfoMap = new Map(persInfoArr);
          */
          // console.log(persInfoMap);
          // console.log(persInfoMap.get(listItem.realSender));
          return persInfoMap.get(listItem.realSender) ? persInfoMap.get(listItem.realSender) : (mailFromName ? mailFromName : mailFromEmail);
        } else if(this.localConfigSetting.displaySetting.recvFromDisplay === xmail.enums.RecvFromDisplayType.ORIGINAL) {
          // return listItem.mailFrom.split('<')[0];
          return mailFromName ? mailFromName : mailFromEmail;
          // let orgInfoEmails = storeLocal.get('ls_org_info').map(item => {
          //   if(item.email !== ''){
          //     return item;
          //   }
          // });
          // orgInfoEmails = orgInfoEmails.filter(item => {return item}); //{{$t("wm_lang_html_b3b1f7")}}undefined
          // let orgInfoArr = [];
          // orgInfoEmails.forEach(item => {
          //   orgInfoArr.push([item.email, item.name]);
          // });
          // let orgInfoMap = new Map(orgInfoArr);
          // // console.log(orgInfoMap);
          // return orgInfoMap.get(email) ? orgInfoMap.get(email) : email;
        } else {
          return mailFromEmail;
        }
      } else {
        //发件箱显示收件人姓名
        // console.log(listItem.mailTo.split('¶'));
        let listMailToNames = [];
        listItem.mailTo.split('¶').forEach(item => {
          let mailToName = emailPart(item, 'name');
          let mailToEmail = emailPart(item, 'email');
          if(this.localConfigSetting.displaySetting.recvFromDisplay === xmail.enums.RecvFromDisplayType.CONTACT) {
            listMailToNames.push(persInfoMap.get(item) ? persInfoMap.get(item) : (mailToName ? mailToName : mailToEmail));
          } else if(this.localConfigSetting.displaySetting.recvFromDisplay === xmail.enums.RecvFromDisplayType.ORIGINAL) {
            listMailToNames.push(mailToName ? mailToName : mailToEmail);
          } else {
            listMailToNames.push(mailToEmail);
          }
        });
        return listMailToNames.toString();
      }
    }
  },
  computed: {
    folderIsStar() {
      let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
      return storeRootFolderId === xmail.enums.FolderType.STAR_BOX_FOLDER_ID
    },
    folderIsGarbage() {
      let storeRootFolderId = belongRootFolderId(this.$store.getters.folderId, this.$store.getters.folders);
      return storeRootFolderId === xmail.enums.FolderType.GARBAGE_MAIL_BOX_FOLDER_ID
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      // console.log(from);
      // console.log(this.$store.getters.mailIndexParamRecord);
      // console.log(this.$route);
      // console.log(this.$store.getters.checkedMails);
      // 邮件索引列表(组件缓存不触发mounted)
      if(from.name === 'info'){
        // let currFid = this.$store.getters.folderId ? this.$store.getters.folderId : 1;
        // console.log(this.$route.params);
        if(this.$route.params.first) {
          this.mailIndexList({id: this.$route.params.fid});
        }
        if(this.$route.params.homeSearch) {
          this.mailIndexList({searchInfo: this.$route.params.search});
        }
        if(this.$route.params.allUnread) {
          this.mailIndexList({filterType: 'unread'});
          this.homeAllUnread = true;
        } else {
          this.homeAllUnread = false;
        }
        // console.log(this.homeAllUnread)
      }
    }
  },
  mounted(){
    // console.log(this.$store.state.folder)
    console.log('--- listBar mounted---');
    if (!storeLocal.get('Pwm-Islogin')) {
      return;
    }
    this.localConfigSetting = storeLocal.get('Pwm-configSetting');
    this.spamMailDeleteTime = this.localConfigSetting.displaySetting.spamMailDeleteTime;
    let currFid = this.$store.getters.folderId ? this.$store.getters.folderId : 1;
    if(this.$route.params.first) {
      this.mailIndexList({id: this.$route.params.fid});
    } else {
      if(this.$route.params.homeSearch) {
        this.mailIndexList({searchInfo: this.$route.params.search})
      } else if(this.$route.params.allUnread) {
        this.mailIndexList({filterType: 'unread'});
        this.homeAllUnread = true;
      } else {
        this.mailIndexList({id: currFid});
        this.homeAllUnread = false;
      }
    }

    let self = this;
    /* 点击生成索引 */
    this.$EventBus.$off("getCurrFid");
    this.$EventBus.$on("getCurrFid",function(data){
      // console.log("getCurrFid");
      if(data.keepParams) {
        self.mailIndexList({keepParams: true});
      } else {
        self.currentPage = 1;
        self.mailIndexParamRecord = {};
        self.mailIndexList({id: data.folderId});
      }
      // self.currentPage = 1;
      // self.mailIndexParamRecord = {};
      // self.mailIndexList({id: data.folderId});
      self.homeAllUnread = false;
      self.$store.commit('SET_ACROSS_COUNT',0);
      self.$store.commit('SET_ACROSS_FLAG', false);
      // self.$store.commit('SET_MAILINDEXPARAM_TYPE', '');
      // self.$store.commit('SET_CHECKED_MAILS',[]);
    });
    /*
    筛选及搜索生成索引
    筛选邮件索引必传id，filterType
    搜索邮件索引必传searchInfo(后端要求不可传id)
    */
    this.$EventBus.$off("filterCurrIndex");
    this.$EventBus.$on("filterCurrIndex",function(data){
      console.log(data);
      // self.mailIndexList(data.fid, data.type)
      self.currentPage = 1;
      if(data.type === 'timeAsc'
        || data.type === 'timeDes'
        || data.type === 'senderAsc'
        || data.type === 'senderDes'
        || data.type === 'subjectAsc'
        || data.type === 'subjectDes'
        || data.type === 'sizeAsc'
        || data.type === 'sizeDes') {
        if(self.indexListStatus() === 'searchStatus') {
          // self.mailIndexList({searchSortType: data.type, searchInfo: data.search});
          self.mailIndexList({sortType: true, searchStatusType: true, filterType: data.type, searchInfo: data.search});
        } else {
          self.mailIndexList({sortType: true, id: data.fid, filterType: data.type, searchInfo: data.search});
        }
      } else {
        if(self.indexListStatus() === 'searchStatus') {
          // self.mailIndexList({searchSortType: data.type, searchInfo: data.search});
          self.mailIndexList({searchStatusType: true, filterType: data.type, searchInfo: data.search});
        } else {
          self.mailIndexList({id: data.fid, filterType: data.type, searchInfo: data.search});
        }
      }

      // console.log(self.$store.getters.checkedMails)
      self.$store.commit('SET_CHECKED_MAILS',[]);
    });
    /*
    更新布局设置
    */
    this.$EventBus.$off("changeListLayoutSet");
    this.$EventBus.$on("changeListLayoutSet",function(data){
      // console.log(data)
      self.layoutType = data.layout;
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .contListOne{
    cursor: pointer;
  }
  .wrap-flex{ display: flex}
  /deep/ .el-table__row{ cursor: pointer}
  .el-table--group::after, .el-table::before{ background-color: transparent;}
  /deep/ .resize-box-full .el-table .el-table__cell{padding:0px;}
</style>



// WEBPACK FOOTER //
// src/components/sub/listBar.vue